import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityFormMode } from '@/common/entityFramework/enumerations/EntityFormMode';
import { useForm } from '@/common/form/FormContext';
import { EnumSelect } from '@/common/form/formFields/EnumSelect'
import { useEffect } from 'react';

export const ProgDateBasis = ({ fieldDef }) => {

  const { entityFormMode } = useEntityMgr();
  const { formValues, assignValue } = useForm();

  useEffect(() => {
    if (entityFormMode === EntityFormMode.VIEW) return; 

    const invDateTypes = ['SUPP', 'MEDI', 'ADAP', 'SPAP', 'JCODE', 'MM'];
    if (invDateTypes.includes(formValues.progType)) {
      assignValue('dateBasis', 'INV_DATE');
      fieldDef.disabled = true;
    } else {
      assignValue('dateBasis', null);
      fieldDef.disabled = false;
    }

  }, [formValues.progType]);

  return <EnumSelect fieldDef={fieldDef} />
}